import _regeneratorRuntime from "D:\\agent\\_work\\100\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _slicedToArray from "D:\\agent\\_work\\100\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _classCallCheck from "D:\\agent\\_work\\100\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import axios from "axios";
import { getApiHeader, getApiHeaderWithContentType } from "./token";
export var UserSearchResults = function UserSearchResults() {
  _classCallCheck(this, UserSearchResults);

  this.users = [];
};

var buildUrl = function buildUrl(baseUrl, params) {
  var queryParams = Object.entries(params).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        _ = _ref2[0],
        value = _ref2[1];

    return value !== undefined;
  }).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];

    return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(String(value)));
  }).join("&");
  return "".concat(baseUrl, "?").concat(queryParams);
};

var getUsers = function getUsers(institutionCode, currentUserSiteRoles, page, pageSize, searchTerm, orderBy, isAscending, filters) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var url, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = buildUrl("api/Users/GetUsers", {
              pageNumber: page,
              pageSize: pageSize,
              searchKeyword: searchTerm,
              sortBy: orderBy,
              orderBy: isAscending ? "asc" : "desc",
              status: filters.status.join(","),
              roles: filters.roles.join(","),
              sites: filters.instituteTypes.join(","),
              siteRole: filters.siteRoles.map(function (sr) {
                return sr.replace(": ", ":");
              }).join(",")
            });
            _context.next = 3;
            return axios.get(url, getApiHeader());

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

var getUser = function getUser(email) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    var url, response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url = buildUrl("api/Users/GetUserByEmail", {
              email: email
            });
            _context2.next = 3;
            return axios.get(url, getApiHeader());

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response.data);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
};

var getInstitutions = function getInstitutions() {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3() {
    var response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return axios.get("api/Users/GetInstitutions", getApiHeader());

          case 2:
            response = _context3.sent;
            return _context3.abrupt("return", response.data);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
};

var updateUser = function updateUser(user) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4() {
    var response;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return axios.put("api/Users/".concat(user.id), user, getApiHeaderWithContentType("application/json"));

          case 3:
            response = _context4.sent;
            return _context4.abrupt("return", response.data);

          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](0);
            throw _context4.t0.response.headers["application-error"];

          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 7]]);
  }));
};

var sendEmail = function sendEmail(user) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5() {
    var response;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return axios.put("api/Users/SendResetPasswordEmail", user, getApiHeaderWithContentType("application/json"));

          case 3:
            response = _context5.sent;
            return _context5.abrupt("return", response.data);

          case 7:
            _context5.prev = 7;
            _context5.t0 = _context5["catch"](0);
            throw _context5.t0.response.headers["application-error"];

          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 7]]);
  }));
};

var addUser = function addUser(user) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee6() {
    var response;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return axios.post("api/Users", user, getApiHeaderWithContentType("application/json"));

          case 3:
            response = _context6.sent;
            return _context6.abrupt("return", response.data);

          case 7:
            _context6.prev = 7;
            _context6.t0 = _context6["catch"](0);
            throw _context6.t0.response.headers["application-error"];

          case 10:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 7]]);
  }));
};

var getAllFilterValues = function getAllFilterValues() {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee7() {
    var response;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return axios.get("api/users/getFilters", getApiHeader());

          case 2:
            response = _context7.sent;
            return _context7.abrupt("return", response.data);

          case 4:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
};

var getPermissions = function getPermissions() {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee8() {
    var response;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return axios.get("api/Users/GetPermissions", getApiHeader());

          case 2:
            response = _context8.sent;
            return _context8.abrupt("return", response.data);

          case 4:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
};

var getRoles = function getRoles() {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee9() {
    var response;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return axios.get("api/Users/GetRoles", getApiHeader());

          case 2:
            response = _context9.sent;
            return _context9.abrupt("return", response.data);

          case 4:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
};

export default {
  getUsers: getUsers,
  getUser: getUser,
  updateUser: updateUser,
  sendEmail: sendEmail,
  addUser: addUser,
  getInstitutions: getInstitutions,
  getAllFilterValues: getAllFilterValues,
  getPermissions: getPermissions,
  getRoles: getRoles
};